import * as constants from '../constants/booking.constants';

interface IBooking {
  selectedTickets: Record<string, any>;
  selectedDate: string | null;
  currentStep: 'dateSelection' | 'ticketSelection';
}

const initialState: IBooking = {
  selectedTickets: {},
  selectedDate: null,
  currentStep: 'dateSelection',
};

export const bookingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case constants.SET_SELECTED_TICKETS:
      return {
        ...state,
        selectedTickets: action.payload,
      };
    case constants.SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.payload,
      };
    case constants.STEP:
      return {
        ...state,
        currentStep: action.payload,
      };
    case constants.RESET:
      return initialState;

    default:
      return state;
  }
};
